<template lang="pug">
SspLayout(area="tnt")
  .row.enable-code-range
    .col-md-12
      form.panel.panel-default(role="form" @submit.prevent="enable()")
        .panel-body
          .form-horizontal
            .form-group
              label.col-sm-2.control-label Section
              .col-sm-4
                input.section-id.form-control(@input="onSectionInput($event.target.value)" v-model="form.sectionId" type="number" placeholder="Finds codes with section id (optional)")
              .col-sm-1(v-if="loading")
                span.fa.fa-spinner.fa-pulse.fa-2x
            .form-group
              label.col-sm-2.control-label First Code
              .col-sm-4
                input.first-code.form-control(type="text" placeholder="First Code" v-model="form.firstCode")
              label.col-sm-1.control-label Last Code
              .col-sm-4
                input.last-code.form-control(type="text" placeholder="Last Code" v-model="form.lastCode")
            .form-group
              label.col-sm-2.control-label Product
              .col-sm-4
                ProductSelect(v-model="form.productId")
              label.col-sm-1.control-label Package
              .col-sm-4
                PackageSelect(v-model="form.packageTypeId")
        .panel-footer
          .text-right
            span.pr20
              span.red(v-if="noFirstCode") {{noFirstCode}}
            SspActionButton(type="submit" :disabled="!isValid" :spinning="enabling" text="Enable")
</template>

<script>
import vSelect from 'vue-select'
import miniToastr from 'mini-toastr'
import debounce from 'debounce'
import TrackNTrace from '@/service/apis/TrackNTrace'
import Core from '@/service/apis/Core'
import Util from '@/service/Util'
import ProductSelect from '@/components/ssp/ProductSelect'
import PackageSelect from '@/components/ssp/PackageSelect'

export default {
  data: () => ({
    enabling: false,
    form: {},
    packageTypes: [],
    noFirstCode: null,
    loading: false
  }),
  created() {
    this.form = this.initialCodeRangeData()
    this.onSectionInput = debounce(this.onSectionInput, 1000)
  },
  methods: {
    initialCodeRangeData() {
      return {
        sectionId: null,
        firstCode: null,
        lastCode: null,
        packageTypeId: null,
        productId: null
      }
    },
    enable() {
      this.enabling = true
      const req = {}

      if (this.form.packageTypeId) {
        req.packageType = { id: this.form.packageTypeId }
      }
      if (this.form.productId) {
        req.product = { id: this.form.productId }
      }
      return TrackNTrace.enableCodeRange(Util.sanitizeCode(this.form.firstCode), Util.sanitizeCode(this.form.lastCode), req)
        .then(() => {
          miniToastr.success('Enabling successful')
          this.noFirstCode = null
          this.errorMsg = null
          this.form = this.initialCodeRangeData()
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.enabling = false
        })
    },
    onSectionInput(id) {
      this.errorMsg = null
      this.noFirstCode = null
      this.getSectionCodes(id)
    },
    getSectionCodes(id) {
      this.loading = true
      Core.getSection(id)
        .then((resp) => {
          if (resp.data.first.code && resp.data.last.code) {
            this.noFirstCode = null
            this.form.firstCode = resp.data.first.code
            this.form.lastCode = resp.data.last.code
            this.firstCodeConfig = resp.data.first.codeConfig
            this.lastCodeConfig = resp.data.last.codeConfig
          } else {
            this.form.firstCode = null
            this.form.lastCode = null
            this.noFirstCode = 'There is no first or/and last code for this section'
          }
          this.loading = false
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    }
  },
  watch: {
    section() {
      if (this.section !== null) {
        Core.getSection(this.section.value)
          .then((resp) => {
            this.firstCode = resp.data.first.code
            this.lastCode = resp.data.last.code
          })
          .catch((e) => {
            this.$emit('error', e)
          })
      } else {
        this.firstCode = null
        this.lastCode = null
      }
    }
  },
  computed: {
    isValid() {
      const packOrProd = this.form.packageTypeId || this.form.productId
      return packOrProd && this.form.firstCode && this.form.lastCode
    }
  },
  components: {
    ProductSelect,
    PackageSelect,
    vSelect
  }
}
</script>

<style lang="scss">
.enable-code-range {
  .pr20 {
    padding-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/EnableCodeRange.vue